import React from 'react';
import styled from 'styled-components';
import * as BuilderUI from '../../BuilderUI';
import MeasureFunctionMenu from './MeasureFunctionMenu';
import { IRowMeta } from '../../../../redux/slices/oldBuilder';
import { IMeasureFunction } from '../../../../utils/apollo/graphqlSchema';

interface IProps {
  rowMeta: IRowMeta;
  measureFunctions: IMeasureFunction[];
}

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding-top: 4px;
  padding-bottom: 4px;
`;

const MeasureFunction = ({ rowMeta, measureFunctions }: IProps) => (
  <Container>
    <BuilderUI.InputLabel>Measure by</BuilderUI.InputLabel>
    <MeasureFunctionMenu
      rowMeta={rowMeta}
      measureFunctions={measureFunctions}
    />
  </Container>
);

export default MeasureFunction;
